import React, { useEffect, useState } from "react";
import axios from "axios";
import { Tag, Modal, Typography, message } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ButtonItem, ListaItems } from "../../../../../Components/Items";
import { WA } from "../../theme";
import { etiquetaTipo } from "../Helpers/interactivosHelpers";
import EditorElemento from "../Editores/EditorElemento";

const { Text } = Typography;

// Administra la biblioteca de mensajes interactivos reutilizables (CRUD).
const BibliotecaElementos = ({ headersToken, empresaId }) => {
  const [elementos, setElementos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editor, setEditor] = useState({ visible: false, elemento: null });

  const headers = { headers: headersToken };

  const cargar = () => {
    setLoading(true);
    axios
      .post("whatsapp/elementoListar", { empresaId }, headers)
      .then((r) => {
        if (r.data.success === 2) setElementos(r.data.elementos || []);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cerrarEditor = (recargar) => {
    setEditor({ visible: false, elemento: null });
    if (recargar) cargar();
  };

  const eliminar = (elemento) => {
    Modal.confirm({
      title: "Eliminar elemento",
      content: `¿Eliminar "${elemento.nombre}"? Esta acción no se puede deshacer.`,
      okText: "Eliminar",
      okButtonProps: { danger: true },
      cancelText: "Cancelar",
      zIndex: 1300,
      onOk: () =>
        axios
          .post("whatsapp/elementoEliminar", { elementoId: elemento._id }, headers)
          .then((r) => {
            if (r.data.success === 2) {
              message.success("Elemento eliminado.");
              setElementos((prev) => prev.filter((e) => e._id !== elemento._id));
            } else {
              message.error(r.data.message || "No se pudo eliminar.");
            }
          })
          .catch(() => message.error("Error de red al eliminar.")),
    });
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
        <ButtonItem
          cyan
          icon={<PlusOutlined />}
          onClick={() => setEditor({ visible: true, elemento: null })}
        >
          Nuevo elemento
        </ButtonItem>
      </div>

      <ListaItems
        dataSource={elementos}
        loading={loading}
        vacioTexto="Aún no hay elementos en la biblioteca"
        titulo={(el) => <Text style={{ color: WA.textPrimary }}>{el.nombre}</Text>}
        descripcion={(el) => (
          <>
            <Tag color={WA.turquesa}>{etiquetaTipo(el.tipo)}</Tag>
            <Text style={{ fontSize: 12, color: WA.textSecondary }}>
              {el.payload?.body?.text?.slice(0, 60) || ""}
            </Text>
          </>
        )}
        acciones={(el) => [
          <ButtonItem key="edit" lima icon={<EditOutlined />} onClick={() => setEditor({ visible: true, elemento: el })} />,
          <ButtonItem key="del" rojo icon={<DeleteOutlined />} onClick={() => eliminar(el)} />,
        ]}
      />

      <EditorElemento
        visible={editor.visible}
        headersToken={headersToken}
        empresaId={empresaId}
        elemento={editor.elemento}
        onCancel={() => cerrarEditor(false)}
        onGuardado={() => cerrarEditor(true)}
      />
    </>
  );
};

export default BibliotecaElementos;
